import { useCallback, useRef, useEffect, useMemo } from 'react';

import { Button, Card} from 'antd';

import Validate from '@Components/Validate';
import MultiLanguageDragUpload from '@Components/BasicComponents/MultiLanguageDragUpload';
import MultiLanguageInput from '@Components/BasicComponents/MultiLanguageInput';

import useIbmS3Uploader from '@/hooks/useIbmS3UploaderNew';

import { filesUploaded, languageRequired, descriptionIsRequiredIfUrlIsPresent, attachmentIsRequiredIfDescriptionIsPresent } from '@/utils/errors/list';

export default function  Attachment({handleChange, attachment, description, remove, id, countryCode, setCountryCode, selector}) {
	const {uploadAtatchment, removeAtatchment, epId} = selector();

	const useIbmS3UploaderRef = useRef(
		useIbmS3Uploader({
			setFile: (value) => uploadAtatchment({...value, id}),
			removeFile: () => removeAtatchment({id, countryCode}),
			bucketPrefix: `${epId?.data}/`
		})
	);
	const {handleUpload, handleRemove,updateBucketPrefix} = useIbmS3UploaderRef.current;

	const onChange = useCallback(
		(param) => {
			return ({countryCode, value}) => handleChange({param, countryCode, value});
		}, []);

	useEffect(() => {
		updateBucketPrefix(`${epId?.data}/`);
	}, [epId?.data, countryCode]);

	const attachmentRequirements = useMemo(() => [filesUploaded, attachmentIsRequiredIfDescriptionIsPresent(description)], [description]);
	const descriptionRequirements = useMemo(() => [languageRequired('en_GB'), descriptionIsRequiredIfUrlIsPresent(attachment)], [attachment]);

	return (
		<Card 
			style={{ marginTop: 16 }}
		>
			<Validate requirements={attachmentRequirements}>
				<MultiLanguageDragUpload
					handleUpload={handleUpload}
					onRemove={handleRemove}
					countryCode={countryCode}
					setCountryCode={setCountryCode}
					value={attachment}
					title="Attatchment"
					maxCount={1}
					accept=".docx, .pdf, .zip, .csv, .xml, .pptx, .xlsx"
					multiple={false}
					bucketPrefix={countryCode}
					allowRemoveOnErrorOnly
				/>
			</Validate>
			<br/>
			<Validate requirements={descriptionRequirements}>
				<MultiLanguageInput
					title="Descriptive text"
					value={description}
					onChange={onChange('description')}
					style={{marginVertical: 10}}
					countryCode={countryCode}
					setCountryCode={setCountryCode}
					tooltip="An alternative description of the link or attachment that summarises the referral information."
				/>
			</Validate>
			<br/>
			<Button type="link" size="small" danger onClick={remove}>Remove</Button>
		</Card>
	);
}